<template>
  <section style="margin-bottom: 18px">
    <div class="right-card">
      <div class="right-card-main">
        <div class="right-card-title clearfix">
          <div class="left">
            <img src="../imgs/hafa.png" alt="" />
          </div>
          <div class="left hafa">{{ $t("哈法看点") }}</div>
          <div class="right moreDetails" @click="hafaMore" style="cursor: pointer">
            <span style="font-size: 16px">{{ $t("更多") }}</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="cl-code">
          <div class="professional">
            <div class="newimg">
              <img
                :src="haFaList[0].images[0]"
                alt=""
                v-if="haFaList.length != 0 && haFaList[0].images"
              />
            </div>
            <p
              v-for="(item, index) in haFaList"
              :key="index"
              @click="getHaFaDetails(item)"
              style="cursor: pointer"
            >
              {{ item.title }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Service from "@/api/request/index.js";
export default {
  name: "rightNews",
  data() {
    return {
      // 页码/条数
      queryParams: {
        page: 1,
        list_rows: 5,
        type_id: "0",
      },
      haFaList: [], // 哈法看点信息列表
    };
  },
  created() {},
  mounted() {
    //   哈法看点信息列表
    this.post62bbf0a622efa();
  },
  methods: {
    //哈法看点更多列表
    hafaMore() {
      this.$router.push({
        url: "/hafaList",
        name: "hafaList",
        query: { name: "hafa" },
      });
    },
    //哈法详情
    getHaFaDetails(item) {
      this.$router.push({
        url: "/hafaDetails",
        name: "hafaDetails",
        query: { userId: item.id },
      });
    },
    // 哈法看点信息列表
    post62bbf0a622efa() {
      Service.post62bbf0a622efa(this.queryParams).then((res) => {
        console.log("res", res);
        if (res.code == 1) {
          this.haFaList = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "themePath/Monitor/cl-css";
@import "themePath/railscasts";
/deep/ .right-card {
  width: 330px;
  // height: 450px;
  // padding: 24px;
}
/deep/ .right-card-main {
  height: 100%;
  // padding: 24px;
  box-sizing: border-box;
}
/deep/ .right-card-title {
  text-align: center;
  padding: 24px;
  padding-bottom: 16px;
  box-sizing: border-box;
  border-bottom: 1px #eeeeee solid;
}
/deep/ .el-carousel__container {
  height: 356px;
}
.code-left:last-child::after {
  width: 0;
}
/deep/.cl-code {
  margin: 0;
}
/deep/ .cl-right {
  margin-top: 0;
}
.professional {
  padding: 24px;
  padding-top: 11px;
  box-sizing: border-box;

  p {
    text-align: left;
    margin-bottom: 16px;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .newimg {
    width: 282px;
    height: 282px;
    margin-bottom: 16px;
    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }
}
.hafa {
  margin-left: 10px;
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: bold;
  color: #333333;
}
.moreDetails {
  font-size: 12px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
}
.right-card-list {
  margin-top: 18px;
  width: 330px;
  height: 354px;
  background: #ffffff;
}
.newsImg {
  width: 330px;
  height: 209px;
  img {
    width: 100%;
    height: 100%;
  }
}
/deep/ .el-tag {
  margin-top: 8px;
}
.newsTitle {
  margin: 8px 26px 16px 16px;
  p {
    font-size: 18px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    display: -webkit-box;
    white-space: normal; // 默认不换行；
    -webkit-line-clamp: 2; // 超出多少行
    -webkit-box-orient: vertical;
  }
  .title {
    margin-top: 16px;
    .newsName {
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: bold;
      color: #666666;
      line-height: 25px;
      margin-left: 8px;
    }
    .newsGuanZhu {
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hafaSee.vue